import { isEmpty } from 'lodash-es'
import { POS_ORDER_TYPE } from '../static'

/**
 * Table-order detail for thermal / plain receipt (matches OrderDetail + API order_type_data.tables).
 */
export const getTableDetailForReceipt = (data) => {
  if (!data) {
    return null
  }
  const typeId =
    data.order_type_id ?? data.invoice_type_id ?? data.order_type?.id ?? data.invoice_type?.id
  if (`${typeId ?? ''}` !== `${POS_ORDER_TYPE.TABLE}`) {
    return null
  }
  const tableData = data.order_type_data || data.invoice_type_data || data.invoice_type_details
  const table = tableData?.tables?.[0]
  if (isEmpty(table)) {
    return null
  }
  return {
    order_name: tableData.order_name || table.name_order || '',
    table_name: table.name || '',
    table_id: table.table_id,
    reserved_count: table.reserved_count,
  }
}

/**
 * Label satu baris untuk print label/ZPL/TSPL: "Meja 2 - Budi" (fallback "#8" bila nama meja tak ada).
 */
export const getTableReceiptLabel = (data) => {
  const detail = getTableDetailForReceipt(data)
  if (!detail) {
    return ''
  }
  const tableName = detail.table_name || (detail.table_id ? `#${detail.table_id}` : '')
  return [tableName, detail.order_name].filter(Boolean).join(' - ')
}
